module.exports = __webpack_public_path__ + "img/18.55d64706.jpg";